import { ClearIcon } from "@mui/x-date-pickers";
import { FormikProps, getIn } from "formik";
import Flex from "../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../components/Text";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";

// Read-only view for the CbtCheckboxNoteList selections. Fields live nested
// under `notePath`: key = boolean flag, `${key}Note` = its free-text note.
// Shows the checked items (in constant order) with their note below the "Add"
// button, mirroring the selected-values view in the evaluation note (ECRH-5429).
interface CbtCheckboxNoteListViewProps {
  formik: FormikProps<Form2Payload>;
  items: readonly { key: string; label: string }[];
  notePath?: string;
  noteLabel?: string;
}

const CbtCheckboxNoteListView = ({
  formik,
  items,
  notePath = "psychotherapyCbtVisitNote",
  noteLabel = "Note",
}: CbtCheckboxNoteListViewProps) => {
  const selected = items.filter((it) =>
    getIn(formik.values, `${notePath}.${it.key}`)
  );

  if (!selected.length) return null;

  const removeItem = (key: string) => {
    formik.setFieldValue(`${notePath}.${key}`, false);
    formik.setFieldValue(`${notePath}.${key}Note`, "");
  };

  return (
    <Flex flexDirection="column" gap={0.5} width="100%" mt={0.5}>
      {selected.map((it) => {
        const note = (getIn(formik.values, `${notePath}.${it.key}Note`) ||
          "") as string;
        return (
          <Flex flexDirection="column" gap={0.25} width="100%" key={it.key}>
            <Flex alignItems="center" gap={0.5}>
              <Text fontSize="14px">{`• ${it.label}`}</Text>
              <ClearIcon
                onClick={() => removeItem(it.key)}
                fontSize="small"
                sx={{ cursor: "pointer", fontSize: "14px" }}
                color="error"
              />
            </Flex>
            {!!note && (
              <Text fontSize="14px" ml={1.5}>
                <Text component="span" fontSize="14px" fontWeight="bold">
                  {`${noteLabel}: `}
                </Text>
                {note}
              </Text>
            )}
          </Flex>
        );
      })}
    </Flex>
  );
};

export default CbtCheckboxNoteListView;
